import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import DataService, { imagePath } from "../../../../config/DataService";
import { Api } from "../../../../config/Api";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import { useSelector } from "react-redux";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const ViewDisbursementData = () => {
  const { state } = PagesIndex.useLocation();
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const [getViewData, setGetViewData] = useState(null);
  const [getViewDataDocuments, setGetViewDataDocuments] = useState(null);
  const [userDetails, setUserDetails] = useState();
  const [approvedAmountData, setApprovedAmountData] = useState(null);
  const [loader, setLoader] = useState(true);
  const initialValues = {};
  const ariaLabel = { "aria-label": "description" };

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const handleBack = () => {
    navigate(`/${rollData}/disbursement-application`, {
      state: { rowID: state?.id, prevState: state.lastStatus },
    });
  };

  const getSingleSahayApplication = async () => {
    try {
      const response = await DataService.get(Api.VIEW_DISBURSEMENT_DATA, {
        params: { applicationId: state?.id },
      });
      if (response.data.status == 200) {
        setUserDetails(response?.data?.data?.application);
        setLoader(false);
        // setGetViewData(response.data.data);
        if (response?.data?.data?.disbursedDetails) {
          setGetViewData(response?.data?.data?.disbursedDetails);
          setApprovedAmountData(
            response?.data?.data?.application?.approveAmount
          );
        } else {
          setGetViewData(response?.data?.data?.application);
          setApprovedAmountData(
            response?.data?.data?.application?.approveAmount
          );
        }
        if (response?.data?.data?.disbursedDocuments) {
          setGetViewDataDocuments(response?.data?.data?.disbursedDocuments);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    }
  };

  useEffect(() => {
    getSingleSahayApplication();
  }, []);

  const { rollPermissionData } = useSelector((state) => state.admin);
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  if (
    rollPermissionData?.permissionArray?.includes("Disbursement_view") ||
    rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box>
                <Index.Box className="title-header-flex-button">
                  <Index.Box className="common-button blue-button flex-start save-btn res-set-search">
                    <Index.Button
                      variant="contained"
                      onClick={() => handleBack()}
                    >
                      Back
                    </Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex">
                  <Index.Box className="title-main mb-10">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="page-title"
                    >
                      View Disbursement Data
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>

              <PagesIndex.Formik
                initialValues={initialValues}
                enableReinitialize
              >
                {({ values }) => (
                  <form>
                    <Index.Box className="">
                      {getViewData?.map((row, index) => (
                        <>
                          <Index.Box className="user-basic-custom-line">
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups"
                            >
                              <Index.Grid container spacing={2}>
                              
                                {getViewDataDocuments?.[index]?.documents
                                  ?.length > 0 && (
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main ">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Documents
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                    <Index.Grid item xs={8}>
                                      <Index.Box className="select-view-document-name">
                                        {getViewDataDocuments?.[
                                          index
                                        ]?.documents?.map((file, index) => (
                                          <Index.Box
                                            className="document-name"
                                            key={index}
                                          >
                                            <Index.Typography
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                // Implement the logic to view the document here
                                                // You can use a modal or a new browser tab/window to show the document
                                                window.open(
                                                  file instanceof Blob
                                                    ? URL.createObjectURL(file)
                                                    : `${imagePath}${file?.Documents}`
                                                );
                                              }}
                                            >
                                              {file?.name
                                                ? file?.name
                                                : file?.filename}
                                            </Index.Typography>
                                          </Index.Box>
                                        ))}
                                      </Index.Box>
                                    </Index.Grid>
                                  </Index.Grid>
                                )}
                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Family Id (કૌટુંબિક આઈડી)
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      type="number"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="familyId"
                                      value={
                                        state?.familyId
                                          ? state?.familyId
                                          : "---"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      User Name (વપરાશકર્તા નામ)
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      type="text"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="userName"
                                      value={
                                        `${state?.mem_fname} ${state?.mem_lname}`
                                          ? `${state?.mem_fname} ${state?.mem_lname}`
                                          : `---`
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Voucher No (વાઉચર નં.)
                                    </Index.Typography>
                                    <Index.TextField
                                      type="number"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="VoucherNo"
                                      value={row?.VoucherNo}
                                      disabled
                                    />
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Cheque No. (ચેક નં.)
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="ChequeNo"
                                      value={row?.ChequeNo}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Bank Issue Name (બેંક ઇશ્યુનું નામ)
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="ChequeNo"
                                      value={row?.BankIssueName}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Typography
                                    component="p"
                                    className="in-label"
                                  >
                                    Cheque Date (તારીખ તપાસો)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border date-input-box">
                                    <Index.LocalizationProvider
                                      dateAdapter={Index.AdapterDayjs}
                                      sx={{ position: "absolute" }}
                                    >
                                      <Index.DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <MobileDatePicker
                                          disabled
                                          value={dayjs(row?.chequeDate)}
                                          format="YYYY-MM-DD"
                                          sx={{
                                            overflowY: "hidden",
                                            position: "relative",
                                            bottom: "8px",
                                            width: "100%",
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: false,
                                            },
                                          }}
                                        />
                                      </Index.DemoContainer>
                                    </Index.LocalizationProvider>
                                  </Index.Box>
                                </Index.Grid>
                                {/* <Index.Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={3}
                                  lg={3}
                                >
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Repay Details (ચુકવણી વિગતો)
                                    </Index.Typography>
                                    <Index.Textarea
                                      style={{
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "4px",
                                      }}
                                      fullWidth
                                      minRows={2}
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="RepayDetail"
                                      value={row?.RepayDetail}
                                      disabled
                                    />
                                  </Index.Box>
                                </Index.Grid> */}
                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Typography
                                    component="p"
                                    className="in-label"
                                  >
                                    Start Date (પ્રારંભ તારીખ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border date-input-box">
                                    <Index.LocalizationProvider
                                      dateAdapter={Index.AdapterDayjs}
                                      sx={{ position: "absolute" }}
                                    >
                                      <Index.DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <MobileDatePicker
                                          disabled
                                          value={dayjs(row?.StartDate)}
                                          format="YYYY-MM-DD"
                                          sx={{
                                            overflowY: "hidden",
                                            position: "relative",
                                            bottom: "8px",
                                            width: "100%",
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: false,
                                            },
                                          }}
                                        />
                                      </Index.DemoContainer>
                                    </Index.LocalizationProvider>
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Typography
                                    component="p"
                                    className="in-label"
                                  >
                                    Check Issue date (ઇશ્યૂ તારીખ તપાસો)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border date-input-box">
                                    <Index.LocalizationProvider
                                      dateAdapter={Index.AdapterDayjs}
                                      sx={{ position: "absolute" }}
                                    >
                                      <Index.DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <MobileDatePicker
                                          name="checkIssueDate"
                                          disabled
                                          value={dayjs(row?.checkIssueDate)}
                                          format="YYYY-MM-DD"
                                          sx={{
                                            overflowY: "hidden",
                                            position: "relative",
                                            bottom: "8px",
                                            width: "100%",
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: false,
                                            },
                                          }}
                                        />
                                      </Index.DemoContainer>
                                    </Index.LocalizationProvider>
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Bank Name (બેંકનું નામ)
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      type="text"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="userName"
                                      value={
                                        state?.bankName
                                          ? state?.bankName
                                          : "---"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <>
                                  <Index.Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={3}
                                    lg={3}
                                  >
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Approved Amount (મંજૂર રકમ)
                                      </Index.Typography>
                                      <Index.TextField
                                        disabled
                                        type="number"
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="approveAmount"
                                        value={state?.ApproveAmount}
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  {/* <Index.Grid
                                          item
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          lg={4}
                                          mb={2}
                                        > */}
                                  {/* <Index.Grid container spacing={2}> */}
                                  {/* Disbursed Amount */}
                                  <Index.Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={3}
                                    lg={3}
                                  >
                                    <Index.Box className="label-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Disbursed Amount (વિતરિત રકમ)
                                      </Index.Typography>

                                      <Index.TextField
                                        type="number"
                                        inputProps={{
                                          ...ariaLabel,
                                        }}
                                        className="basic-input input-width"
                                        name="disbursedAmount"
                                        value={row?.disbursedAmount}
                                        disabled
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  {/* Pending Amount */}
                                  <Index.Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={3}
                                    lg={3}
                                  >
                                    <Index.Box className="label-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Pending Amount (બાકી રકમ)
                                      </Index.Typography>
                                      <Index.TextField
                                        disabled
                                        type="number"
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name={`pendingAmount`}
                                        value={row?.pendingAmount}
                                      />
                                    </Index.Box>
                                  </Index.Grid>
                                  {/* </Index.Grid> */}
                                  {/* </Index.Grid> */}
                                </>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Box>
                        </>
                      ))}

                      <Index.Box className="line" mt={3} mb={3}></Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Box>
        </>
      )}
    </>
  );
};

export default ViewDisbursementData;
